import { useQuery } from "react-query";
import { getDataExpectations } from "../GetDataStaffRequests/getDataExpectations";

export default function useGetExpectations() {
  return useQuery({
    queryKey: ["getDataStaffBonus"],
    queryFn: () => getDataExpectations(),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    staleTime: 0,
  });
}
